export default (initialState = {}) => {
  return () => {
    return {
      billing_address: "",
      buyer: null,
      date: null,
      delivery_date: null,
      delivery_type: "FOR",
      expiry_date: null,
      lineitems: [],
      owner: null,
      owner_name: "",
      payment_terms: "",
      shipping_address: "",
      total_tax: 0,
      total_amount: 0,
      rfq: null,
      associated_agent: null,
      ...initialState,
    };
  };
};
